import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { IconButton, IconButtonProps, styled } from "@mui/material";

interface ExpandMoreProps extends IconButtonProps {
	expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
	const { expand, children, ...other } = props;
	return (
		<IconButton {...other}>
			<ExpandMoreIcon />
			{children}
		</IconButton>
	);
})(({ theme, expand }) => ({
	transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
	marginLeft: "auto",
	transition: theme.transitions.create("transform", {
		duration: theme.transitions.duration.shortest,
	}),
}));

export default ExpandMore;
